"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const plugins_1 = require("../plugins");
const Cesium = window.Cesium;
/* LOG
    * created (17/06/2012)
*/
class SceneLiveDataController extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.controls = {
            active: { value: false, type: 'check' },
        };
    }
    init() {
        // create data store here
    }
    end() {
        // remove data store here
    }
}
SceneLiveDataController.meta = {
    label: 'PLUGINS.LIVE_DATA_SCENE_CONTROLLER.LABEL',
    name: 'live-data-scene-controller',
    translator: 'PLUGINS.LIVE_DATA_SCENE_CONTROLLER',
    tooltip: 'PLUGINS.LIVE_DATA_SCENE_CONTROLLER.TOOLTIP',
    shortcut: true,
    shortcutOnlyVisible: true,
    icon: 'rss',
    category: plugins_1.FdmPlugin.category.experimental,
    types: [plugins_1.FdmPlugin.types.sceneController],
    cardinality: plugins_1.FdmPlugin.cardinality.one,
};
exports.SceneLiveDataController = SceneLiveDataController;
